<template>
  <drawer
    v-model="display"
    :width="300"
    background-color="#0D171A"
    class="filter-drawer"
  >
    <v-btn
      color="primary"
      height="40px"
      class="mr-2 vertical-align-top"
      @click="invertSortDirection"
    >
      <font-awesome-icon
        :icon="['fas', directionIcon]"
      />
    </v-btn>
    <v-select
      v-model="cardFilterStore.filter.sort.property"
      :items="sortItems"
      variant="solo"
      bg-color="primary"
      color="white"
      item-color="white"
      menu-icon="fa-caret-down"
      density="compact"
      :placeholder="$t('filter_drawer.sort_by')"
      :list-props="{ bgColor: 'primary' }"
      class="sort-select d-inline-block"
    />
    <v-select
      v-model="cardFilterStore.filter.property.scarcity"
      :items="scarcityItems"
      variant="solo"
      chips
      bg-color="primary"
      density="comfortable"
      color="white"
      item-color="white"
      menu-icon="fa-caret-down"
      item-icon="square"
      closable-chips
      multiple
      single-line
      :label="$t('filter_drawer.scarcity')"
      :list-props="{ bgColor: 'primary' }"
    >
      <template #item = "{ item, props }" >
        <v-list-item
          v-bind="props"
        >
          <template v-slot:prepend>
            <v-checkbox
              false-icon="far fa-square"
              true-icon="fas fa-square-check"
              :model-value="cardFilterStore.filter.property.scarcity.includes(item.value)"
              @update:model-value="toggleSelection(cardFilterStore.filter.property.scarcity, item.value)"
              hide-details
              density="compact"
            />
          </template>
        </v-list-item>
      </template>
      <template #chip="{ props }">
        <v-chip
          v-bind="props"
          close-icon="fas fa-circle-xmark"
        ></v-chip>
      </template>
    </v-select>
    <v-select
      v-model="cardFilterStore.filter.property.position"
      :items="positionItems"
      variant="solo"
      chips
      bg-color="primary"
      density="comfortable"
      color="white"
      item-color="white"
      menu-icon="fa-caret-down"
      closable-chips
      multiple
      single-line
      :label="$t('filter_drawer.position')"
      :list-props="{ bgColor: 'primary' }"
    >
      <template #item="{ item, props }">
        <v-list-item
          v-bind="props"
          class="d-flex align-center"
        >
          <template #prepend>
            <v-checkbox
              false-icon="far fa-square"
              true-icon="fas fa-square-check"
              :model-value="cardFilterStore.filter.property.position.includes(item.value)"
              @update:model-value="toggleSelection(cardFilterStore.filter.property.position, item.value)"
              density="compact"
              hide-details
            />
          </template>
        </v-list-item>
      </template>
      <template #chip="{ props }">
        <v-chip
          v-bind="props"
          close-icon="fas fa-circle-xmark"
        ></v-chip>
      </template>
    </v-select>
  </drawer>
</template>

<script>
import Drawer from '@/components/Drawer.vue';
import { useCardFilterStore } from '@/store/cardFilter.module';

export default {
  name: 'FilterDrawer',
  components: {
    Drawer,
  },
  setup() {
    const cardFilterStore = useCardFilterStore();

    return { cardFilterStore };
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sortItems: [
        {
          title: 'L15',
          value: 'last15Average',
        },
        {
          title: this.$t('filter_drawer.last_recruits'),
          value: 'ownedFrom',
        },
        {
          title: this.$t('filter_drawer.name'),
          value: 'name',
        },
      ],
      scarcityItems: [
        {
          title: this.$t('filter_drawer.unique'),
          value: 'unique',
        },
        {
          title: this.$t('filter_drawer.super_rare'),
          value: 'super_rare',
        },
        {
          title: this.$t('filter_drawer.rare'),
          value: 'rare',
        },
        {
          title: this.$t('filter_drawer.limited'),
          value: 'limited',
        },
      ],
      positionItems: [
        {
          title: this.$t('filter_drawer.forward'),
          value: this.$consts.POSITION.FORWARD,
        },
        {
          title: this.$t('filter_drawer.midfielder'),
          value: this.$consts.POSITION.MIDFIELDER,
        },
        {
          title: this.$t('filter_drawer.defender'),
          value: this.$consts.POSITION.DEFENDER,
        },
        {
          title: this.$t('filter_drawer.goalkeeper'),
          value: this.$consts.POSITION.GOALKEEPER,
        },
      ],
    };
  },
  computed: {
    display: {
      get() { return this.modelValue; },
      set(display) {
        this.$emit('update:model-value', display);
      },
    },
    directionIcon() {
      return this.cardFilterStore.filter.sort.direction === 'ASC' ? 'sort-amount-down-alt' : 'sort-amount-up-alt';
    },
  },
  methods: {
    invertSortDirection() {
      this.cardFilterStore.invertSortDirection();
    },
    toggleSelection (items,value) {
      if (items.value.includes(value)) {
        items.value = items.value.filter((v) => v !== value);
      } else {
        items.value.push(value);
      }
    },
  },
};
</script>
